import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
  message,
} from "antd";

import {
  EditOutlined,
  PercentageOutlined,
} from "@ant-design/icons";
import { AdherentsService } from "../Services/AdherentsService";
import { PrestationsService } from "../Services/PrestationsService";
import { TypesBenefsService } from "../Services/TypesBenefsServices";
import { TpecService } from "../Services/TpecService";

const { Title } = Typography;
const Tpec = () => {
  const adherentsService = new AdherentsService();
  const prestationService = new PrestationsService();
  const typeBenefService = new TypesBenefsService();
  const tpecService = new TpecService();
  const [adherents, setAdherents] = useState([]);
  const [prestations, setPrestations] = useState([]);
  const [benefs, setBenefs] = useState([]);
  const [tauxpc, setTauxpc] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [inputValueOne, setInputValueOne] = useState(80); // Initialisation avec la valeur par défaut de 80
  const [inputValueTwo, setInputValueTwo] = useState(0);
  const [inputValueThree, setInputValueThree] = useState(0);
  const [inputValuetxfs, setInputValueTxfs] = useState(0);
  const [plafondActe, setPlafondActe] = useState(0);
  const [plafondMensuel, setPlafondMensuel] = useState(0);
  const [plafondAnnuel, setPlafondAnnuel] = useState(0);
  //const [montTarifJour, setMontTarifJour] = useState(0);
  const [nbJourMax, setNbJouMax] = useState(0);
  const [isPlafondModalVisible, setIsPlafondModalVisible] = useState(false);
  // const [tarifJour, setTarifJour] = useState(false);
  const [selectedAdherent, setSelectedAdherent] = useState(null);
  const [selectePrestation, setSelectedPrestation] = useState("All");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchAdherents = async () => {
      try {
        const data = await adherentsService.getAllAdherents();
        setAdherents(data); // Stockez les données dans l'état
        if (data.length > 0) {

          setSelectedAdherent(data[0].codeadht);
        }

      } catch (error) {
        console.log("Erreur lors de la récupération des adhérents:", error);
      }
    };

    fetchAdherents();
  }, []);
  useEffect(() => {
    const fetchPrestation = async () => {
      try {
        const data = await prestationService.getAllPrestation();
        setPrestations(data); // Stockez les données dans l'état
        if (data.length > 0) {

          selectePrestation(data[0].codeadht);
        }
      } catch (error) {
        console.log("Erreur lors de la récupération des adhérents:", error);
      }
    };

    fetchPrestation();
  }, []);

  useEffect(() => {
    const fetchTypeBenef = async () => {
      try {
        const data = await typeBenefService.getAllTypesBenefs();
        setBenefs(data);

      } catch (error) {
        console.log("Erreur lors de la récupération des adhérents:", error);
      }
    };

    fetchTypeBenef();
  }, []);
  const fetchTauxpc = async () => {
    if (selectedAdherent) {
      try {
        const data = await adherentsService.getTauxpc(selectedAdherent);
        setTauxpc(data);

        let filteredData = data;
        if (selectePrestation !== "All") {
          filteredData = data.filter(d => d.codeprest === selectePrestation);
        }
        setTableData(filteredData);
      } catch (error) {
        console.error("Erreur lors de la récupération des taux PC:", error);
      }
    }
  };

  useEffect(() => {
    fetchTauxpc();
  }, [selectedAdherent, selectePrestation]); // Ajouter selectedPrestation aux dépendances

  const handleOpenPlafondModal = () => {
    setIsPlafondModalVisible(true);
  };
  /* const onchangeTarifJour = () => {
    setTarifJour(!tarifJour);

  }; */

  const handlePlafondModalOk = () => {
    // Ferme le modal et sauvegarde les valeurs saisies
    setIsPlafondModalVisible(false);
    message.success("Plafonds mis à jour.");
  };

  const handlePlafondModalCancel = () => {
    setIsPlafondModalVisible(false);
  };


  const showModal = (record) => {
    setIsModalVisible(true);
    setSelectedRowData(record);
    const selectedBenef = benefs.find(benef => benef.codetype === record.typebenef);
    const libtype = selectedBenef ? selectedBenef.libtype : '';
    const codetype = selectedBenef ? selectedBenef.codetype : '';

    form.setFieldsValue({
      fulname: `${record.codeprest}-${record.intitule}`,
      codeprest: record.codeprest,
      codetype: codetype, // Assurez-vous que cela correspond à votre structure de données
      libtype: libtype,
      txpc: record.txpc,
      txpc_fs: record.txpc_fs,
      taux_excep: record.taux_excep,
      txpc_na: record.txpc_na,
      plafond: record.plafond,
      forfait: record.forfait,
      nb_jour_max: record.nb_jour_max,
      plafond_mens: record.plafond_mens, // Supposons que vous avez un champ plafondMensuel
      plafond_annuel: record.plafond_annuel,
    });
  };

  const handleOk = () => {
    form.submit();
  };


  const applyTauxpc = async () => {
    const docData = {
      codeprest: selectePrestation,
      codesoc: selectedAdherent,
      txpc: inputValueOne,
      txpc_na: inputValueTwo,
      txpc_fs: inputValuetxfs,
      taux_excep: inputValueThree,
      plafond: plafondActe,
      plafond_annuel: plafondAnnuel,
      plafond_mens: plafondMensuel,
      //tarif_jour: tarifJour,
      //mont_tarif_jour:montTarifJour,
      nb_jour_max: nbJourMax
    };

    try {
      await tpecService.AddTauxpc(docData);
      message.success('Taux appliqué avec succès');
      fetchTauxpc();
    } catch (error) {
      message.error('Erreur lors de l\'application du taux');
    }
  };

  const onFinish = async (values) => {
    try {
      // Trouver la prestation spécifique parmi les données préchargées
      const prestationData = prestations.find(p => p.codeprest === values.codeprest);

      if (!prestationData) {
        console.error("Prestation non trouvée avec le code:", values.codeprest);
        message.error("Prestation non trouvée.");
        return;
      }



      const updatedPrestation = {
        Prestation: {
          fulname: `${prestationData.codeprest}-${prestationData.intitule}`,
          codeprest: prestationData.codeprest,
          codesoc: selectedRowData.codesoc,
          compte: selectedRowData.compte,
          intitule: prestationData.intitule,
          datecreation: prestationData.datecreation,
          user_id: null,
        },
        Typebeneficiaire: {
          codetype: values.codetype,
          libtype: values.libtype
        },

        codeprest: prestationData.codeprest,
        codesoc: selectedRowData.codesoc,
        numligne: tauxpc.numligne,
        forfait: values.forfait,
        numligne: selectedRowData.numligne,
        compte: selectedRowData.compte,
        plafond: values.plafond,
        plafond_mens: values.plafond_mens,
        plafond_annuel: values.plafond_annuel,
        txpc: values.txpc,
        txpc_na: values.txpc_na,
        txpc_fs: values.txpc_fs,
        taux_excep: values.taux_excep,
        typebenef: values.codetype
      };

      await tpecService.updateTpec(updatedPrestation);


      message.success('Mise à jour réussie.');
      setIsModalVisible(false); // Fermer le modal après la soumission réussie
      await fetchTauxpc();
    } catch (error) {
      console.error('Erreur lors de la mise à jour :', error);
      message.error('Erreur lors de la mise à jour.');
    }
  };


  const handleCancel = () => {
    setIsModalVisible(false);
  };


  const onchangePrestation = (value) => {
    setSelectedPrestation(value);
  };
  const columns = [
    {
      title: "Code Soc",
      dataIndex: "codesoc",
      key: "codesoc",
      align: "center",
      sorter: (a, b) => (String(a.codesoc) || "").localeCompare(String(b.codesoc) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Code Prest",
      dataIndex: "codeprest",
      key: "codeprest",
      align: "center",
      sorter: (a, b) => (String(a.codeprest) || "").localeCompare(String(b.codeprest) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Intitulé",
      dataIndex: "intitule",
      key: "intitule",
      sorter: (a, b) => (String(a.intitule) || "").localeCompare(String(b.intitule) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Type Benef",
      dataIndex: "typebenef",
      key: "typebenef",
      render: (codetype) => {
        const benef = benefs.find(b => b.codetype === codetype);
        const libtype = benef ? benef.libtype : "Inconnu";
        return <span>{libtype}</span>;
      },
      sorter: (a, b) => (String(a.typebenef) || "").localeCompare(String(b.typebenef) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Taux IPM",
      dataIndex: "txpc",
      key: "txpc",
      align: "right",
      render: (text) => <strong>{text || " "} %</strong>, // Gérer null/undefined
      sorter: (a, b) => (a.txpc || 0) - (b.txpc || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Taux FS",
      dataIndex: "txpc_fs",
      key: "txpc_fs",
      align: "right",
      render: (text) => <strong>{text || " "} %</strong>, // Gérer null/undefined
      sorter: (a, b) => (a.txpc_fs || 0) - (b.txpc_fs || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Taux Excep",
      dataIndex: "taux_excep",
      key: "taux_excep",
      align: "right",
      render: (text) => <strong>{text || " "} %</strong>, // Gérer null/undefined
      sorter: (a, b) => (a.taux_excep || 0) - (b.taux_excep || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Taux Non Agrée",
      dataIndex: "txpc_na",
      key: "txpc_na",
      align: "right",
      render: (text) => <strong>{text || " "} %</strong>, // Gérer null/undefined
      sorter: (a, b) => (a.txpc_na || 0) - (b.txpc_na || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Plafond / Acte",
      dataIndex: "plafond",
      key: "plafond",
      align: "right",
      render: (text) => <strong>{text} CFA</strong>, // Gérer null/undefined
      sorter: (a, b) => (a.plafond || 0) - (b.plafond || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Plafond Mensuel",
      dataIndex: "plafond_mens",
      key: "plafond_mens",
      align: "right",
      render: (text) => <strong>{text} CFA</strong>, // Gérer null/undefined
      sorter: (a, b) => (a.plafond_mens || 0) - (b.plafond_mens || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Plafond Annuel",
      dataIndex: "plafond_annuel",
      key: "plafond_annuel",
      align: "right",
      render: (text) => <strong>{text} CFA</strong>, // Gérer null/undefined
      sorter: (a, b) => (a.plafond_annuel || 0) - (b.plafond_annuel || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right", // Fixe la colonne à droite
      render: (text, record) => (
        <span>
          <Tooltip title="Modifier">
            <EditOutlined
              style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
              onClick={() => showModal(record)}
            />
          </Tooltip>
        </span>
      ),
    },
  ];

  const selectedAdherentDetails = adherents.find(adherent => adherent.codeadht === selectedAdherent);
  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <PercentageOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Taux de prise en charge
        </span>
      </div>
      <Row
        gutter={16}
        justify="space-between"
        align="middle"
        style={{ marginBottom: "16px" }}
      >

        <Col
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "start",
          }}
        >

          <Space>
            <Space direction="vertical" style={{ marginRight: 12, textAlign: 'left' }}>
              <label >Société</label>
              <Select
                bordered={false}
                style={{ width: 300, borderBottom: "2px solid #030303" }}
                showSearch
                onChange={(value) => setSelectedAdherent(value)}
                value={selectedAdherent}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                <Select.Option value="All">Toutes les sociétés</Select.Option>
                {adherents.map((adherent) => (
                  <Select.Option
                    key={adherent.codeadht}
                    value={adherent.codeadht}
                  >
                    {`${adherent.codeadht}-${adherent.intitule}`}
                  </Select.Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ marginRight: 12, textAlign: 'left' }}>
              <label >Taux IPM</label>
              <InputNumber
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: 100 }}
                value={inputValueOne}
                onChange={setInputValueOne}
              />
            </Space>
            <Space direction="vertical" style={{ marginRight: 12, textAlign: 'left' }}>
              <label>Taux FS/Assur </label>
              <InputNumber
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: 100 }}
                value={inputValuetxfs}
                onChange={setInputValueTxfs}
              />
            </Space>
            <Space direction="vertical" style={{ textAlign: 'left' }}>
              <label>Taux Excep</label>
              <InputNumber
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: 100 }}
                value={inputValueThree}
                onChange={setInputValueThree}
              />
            </Space>
            <Space direction="vertical" style={{ textAlign: 'left' }}>
              <label>Taux Non Agrée</label>
              <InputNumber
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: 100 }}
                value={inputValueTwo}
                onChange={setInputValueTwo}
              />
            </Space>
            <span style={{ display: "flex", marginTop: "30px" }}>
              <Button type="primary" onClick={handleOpenPlafondModal}>
                Saisir Plafond(s)
              </Button>
            </span>

          </Space>
        </Col>
        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
          <Space direction="vertical" style={{ marginRight: 12, textAlign: 'left' }}>
            <label >Prestation</label>
            <Select
              title="prestation"
              bordered={false}
              showSearch
              style={{
                width: 250,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              defaultValue={selectePrestation} onChange={onchangePrestation}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
            >
              <Select.Option value="All">Toutes</Select.Option>
              {prestations.map((prestation) => (
                <Select.Option
                  key={prestation.codeprest}
                  value={prestation.codeprest}
                >
                  {`${prestation.codeprest}-${prestation.intitule}`}
                </Select.Option>
              ))}
            </Select>
          </Space>
          <Space style={{ marginTop: '28px' }}>
            <Button type="ghost" className="buttonExport" onClick={applyTauxpc}>Appliquer</Button>
          </Space>
        </Col>
      </Row>
      <Modal
        title={`Modification de Taux de Prise en Charge ( ${selectedAdherentDetails?.intitule} )`}
        open={isModalVisible}
        onCancel={handleCancel}
        width={800}
        style={{
          top: 20,
        }}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Fermer
          </Button>,
          <Button key="submit" className="Buttonvalid" onClick={handleOk}>
            Enregistrer
          </Button>,
        ]}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Nature Prestation" name="codeprest">
                <Select style={{ width: "100%" }}>
                  {prestations.map(prestation => (

                    <Select.Option
                      key={prestation.codeprest}
                      value={prestation.codeprest}
                    >
                      {prestation.codeprest}-{prestation.intitule}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Type Bénéficiaire" name="libtype">
                <Select style={{ width: "100%" }}>
                  {benefs.map(benef => (
                    <Select.Option key={benef.codetype} value={benef.libtype}>
                      {benef.libtype}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Taux FS" name="txpc_fs">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Taux Excep" name="taux_excep">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Taux NA" name="txpc_na">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="codetype" hidden={true}>
                <Input hidden />
              </Form.Item>


              <Form.Item label="Taux IPM" name="txpc">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Plafond" name="plafond">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Nombre de Jour Max" name="nb_jour_max">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Plafond Mensuel" name="plafond_mens">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Plafond Annuel" name="plafond_annuel">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Card>

        <Modal
          title="Saisir Plafonds"
          open={isPlafondModalVisible}
          onOk={handlePlafondModalOk}
          onCancel={handlePlafondModalCancel}
          okText="OK"
          cancelText="Annuler"
          maskClosable={false}
        >
          <Form layout="vertical">
            <Form.Item label="Plafond Acte">
              <InputNumber
                style={{ width: "100%" }}
                value={plafondActe}
                onChange={setPlafondActe}
              />
            </Form.Item>
            <Form.Item label="Plafond Mensuel">
              <InputNumber
                style={{ width: "100%" }}
                value={plafondMensuel}
                onChange={setPlafondMensuel}
              />
            </Form.Item>
            <Form.Item label="Plafond Annuel">
              <InputNumber
                style={{ width: "100%" }}
                value={plafondAnnuel}
                onChange={setPlafondAnnuel}
              />
            </Form.Item>
            {/*   <Form.Item label="Tarif jour" >
            <Checkbox
              style={{ width: "100%" }}
              value={tarifJour}
              onChange={onchangeTarifJour}
              
            />
          </Form.Item>
          {tarifJour &&
          <>
 <Form.Item label="Montant Tarif jour" >
           
           <InputNumber
              value={montTarifJour}
              onChange={setMontTarifJour}
              style={{width:'100%'}} />
       
         </Form.Item> */}

            {/*  </>

          } */}




          </Form>
        </Modal>
        <Table
          scroll={{
            x: true,
          }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header2-table my-custom-table"
          bordered
          showSorterTooltip={false}
          columns={columns}
          dataSource={tableData}
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
            showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
            pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
            onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
          }}
        />
      </Card>
    </div>
  );
};

export default Tpec;
